import { useState, useEffect } from "react";
import { C, S, BASE } from '../constants';
import { fmtUAH } from '../utils';
import Img from './Img';
import ProdLink from './ProdLink';

export default function CatModal({ name, dateFrom, dateTo, onClose }) {
  const [prods, setProds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("crm_token");
      let url = `${BASE}/api/category/${encodeURIComponent(name)}`;
      if (dateFrom && dateTo) url += `?date_from=${dateFrom}&date_to=${dateTo}`;
      else url += `?days=30`;
      const res = await fetch(url, { headers: { Authorization: "Bearer " + token } });
      const d = await res.json();
      setProds(d.products || []);
      setLoading(false);
    })();
  }, [name, dateFrom, dateTo]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.75)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 16,
        width: "85%", maxWidth: 860, maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 24px", borderBottom: `1px solid ${C.border}`,
          display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.text1 }}>📂 {name}</div>
            <div style={{ fontSize: 12, color: C.text3, marginTop: 2 }}>
              {prods.length} товарів · {dateFrom && dateTo ? `${dateFrom} — ${dateTo}` : "останні 30 днів"}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: C.text3, fontSize: 22, cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ overflow: "auto", padding: "0 24px 20px" }}>
          {loading ? (
            <div style={{ textAlign: "center", color: C.text3, padding: 40 }}>Завантаження...</div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr>
                  {["Фото", "ID", "Товар", "Артикул", "Виручка", "К-сть"].map(h => (
                    <th key={h} style={S.th(false)}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {prods.map((p, i) => (
                  <tr key={i}>
                    <td style={S.td}><Img src={p.image_url} size={32} /></td>
                    <td style={{ ...S.td, color: C.blue, fontFamily: "monospace", fontSize: 11 }}>{p.product_id}</td>
                    <td style={{ ...S.td, maxWidth: 300 }}>
                      <ProdLink name={p.name} article={p.article} productId={p.product_id} />
                    </td>
                    <td style={{ ...S.td, color: C.text4, fontFamily: "monospace", fontSize: 11 }}>{p.article}</td>
                    <td style={{ ...S.td, color: C.text1, fontWeight: 700 }}>{fmtUAH(p.revenue)}</td>
                    <td style={{ ...S.td, color: C.text2 }}>{p.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
